<template>
  <div :class="['widget-item', { 'hidden-mobile': hiddenMobile }]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'WidgetContainer',
  props: {
    hiddenMobile: {
      type: Boolean,
      default: false,
    },
  }
}
</script>